import { Group, Highlight } from "@mantine/core";
import { IconAlertTriangleFilled } from "@tabler/icons-react";
import { THEME_VARS } from "../../../../utils/constants";

interface SiteTitleProps {
  icon?: React.ReactNode;
  text: string;
  highlight?: string;
  errorText?: string;
}

function SiteTitle({ icon, text, errorText, highlight = "" }: SiteTitleProps) {
  return (
    <Group align="center" justify="space-between">
      <Group fw={500} gap="xs">
        {icon}
        <Highlight highlight={highlight}>{text}</Highlight>
      </Group>
      {errorText && (
        <Group fz="sm" gap="xs">
          <IconAlertTriangleFilled color={THEME_VARS.warning[6]} size={16} />
          {errorText}
        </Group>
      )}
    </Group>
  );
}

export { SiteTitle };
